// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1CLtd","content":"GlobalSearch_content__2RAiK"};